module.exports = __webpack_public_path__ + "img/destination.7f5aeb24.png";